import { formatDate } from "@/helpers/date_helper";
import { isMobile } from "react-device-detect";

export const DateColumn = ({ value, onClick }) => {
  return (
    value && (
      <div onClick={onClick} style={{ cursor: "pointer", display: "flex", alignItems: "center", marginTop: isMobile? "0px" : "10px" }}>
        <div>{formatDate(value)}</div>
      </div>
    )
  );
};
